// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const deleteTimesheetProposalPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.coerce.string().describe("Proposal ID (uuid)"),
});

export const deleteTimesheetProposalHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Proposal deleted successfully
 */
export const deleteTimesheetProposal200Schema = z.object({
  message: z.optional(z.coerce.string()),
});

/**
 * @description Proposal not found
 */
export const deleteTimesheetProposal404Schema = z.object({
  message: z.coerce.string(),
});

export const deleteTimesheetProposalMutationResponseSchema = z.lazy(() => deleteTimesheetProposal200Schema);
